import mask from 'json-mask';
import { fetchJSON } from '@bonnet/core/fetch';
import { cmApiUrl } from '@atc/cm-api-url';

export const consumerBrowserHistoryFetcher = async (pixAllId, debug) => {
    const options = {
        headers: {
            'x-api-key': 'eWosxtgfap17vZ26K70x489wmxf22z5v4x2vEQY1',
        },
        circuitBreaker: {
            timeout: 5000,
            resetTimeout: 300000,
            fallback: null,
        },
    };

    const endpoint = 'https://consumer-browsing-history.prod.duvh.dealer.com/history/' + pixAllId;
    const queryString = '?pagetypefilter=search' + (debug ? '&debug=true' : '');
    const response = await fetchJSON(endpoint + queryString, options);
    const filteredTradeInData = response.filter(
        ({ pageLabel }) => pageLabel != null && pageLabel === 'ymmtrimtisellovr_selltrade'
    );
    const maskedFilteredTradeInData = mask(
        filteredTradeInData,
        'make,model,price,year,eventTimestamp,url,searchZipCode'
    );
    return { kbbTradeIns: maskedFilteredTradeInData };
};

export const vrsServiceFetcher = (endpoint, options = {}) =>
    fetchJSON(`https://www.autotrader.com/cars-for-sale/vrs${endpoint}`, {
        ...options,
        circuitBreaker: {
            timeout: 5000,
            resetTimeout: 300000,
            fallback: {},
        },
    });

export const icoFetcher = (query) =>
    fetchJSON(`https://www.autotrader.com/cars-for-sale/ico/offers/v1/offers`, { query });

export const PaymentCalculationFetcher = (value, fetchTotalPayment = false) =>
    fetchJSON(
        `https://www.autotrader.com${cmApiUrl('/rest/retailing/')}${fetchTotalPayment ? 'budget' : 'payments'}?${value}&defaultRate=true`,
        {
            circuitBreaker: {
                timeout: 5000,
                resetTimeout: 300000,
                fallback: { rates: {} },
            },
            // credentials: 'include',
            // headers: {
            //     'X-fwd-svc': 'atc',
            // },
        }
    );

export const interestRateFetcher = () =>
    fetchJSON('https://s3.amazonaws.com/atc-interest-rates.awsacs.autotrader.com/rates.json');

export default {
    consumerBrowserHistoryFetcher,
    vrsServiceFetcher,
    icoFetcher,
    PaymentCalculationFetcher,
    interestRateFetcher,
};
